import { Serie } from "./Serie";

export class RateData {
   name: string;
   series: Serie[];

   constructor(name: string, series: Serie[]) {
       this.name=name;
       this.series = series;
   }    
}
